<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Reservas de crudo en México</h1>
      <hr/>

      <p class="texto-principal">Las reservas de petróleo se dividen en probadas, probables y posibles. Las reservas probadas se considera que tienen una probabilidad del 90% de poderse extraer en las condiciones técnicas y económicas presentes. En el caso de las probables y posibles este valor corresponde a 50% y 10%, respectivamente. La suma de las primeras dos se define como reservas 2P y la suma de las tres como reservas 3P.</p>
      
      <img src="@/assets/img/planeas/hidrocarburos/reservas-clasificacion.png" style="max-width: 350px;" class="img-center"/>
      <p class="texto-notas texto-centrado">Figura 1. Clasificación de Reservas</p>

      <p class="texto-principal">Las reservas de crudo de México han ido constantemente a la baja. Al 1 de enero de 2022, las reservas probadas correspondían a 6,120 MMdb (CNH, 2022), lo que equivale a 9.7 años de la producción de 2020. Si tomamos en cuenta las reservas 3P, serían 27 años.</p>
      
    </div>

    <div>
    <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Reservas de petróleo crudo</h3>
            <p class="texto-notas">Datos en MMB. Actualización: 2023.</p>
          </div>
          <div class="contenido">
            <div class="barrasReservas" ref="barrasReservas">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas"></p>
          </div>
      </div>

    <br>

    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      
      <p class="texto-primario">Las reservas de crudo históricamente se encuentran concentradas en la Provincia Petrolera de Cuencas del Sureste. Para 2022, la provincia reporta el 81% de las reservas 1P, y el 73% y 70% de las reservas 2P y 3P, respectivamente. La segunda provincia petrolera por reservas es la de Tampico Misantla, que tiene el 14% de las reservas 1P de crudo, y el 23% y 25% de las reservas 2P y 3P, respectivamente.</p>

    </div>

    <div>
      <dai-tarjeta-contenedor-mapa :permitir-colapso="true" altura-colapsada="80vh">
      
      <template v-slot:header>
            <h3>Distribución de las Reservas por Provincia Petrolera 2020</h3> 

            <dai-selector-mapa 
            v-model="selectorCategoria"
            class="control-large" 
            @change="cambioSelector"
            >
                <option value="1p">1P (Probadas)</option>
                <option value="2p">2P (1P + Probables)</option>
                <option value="3p">3P (2P + Posibles)</option>
            </dai-selector-mapa>

            <p class="texto-notas " v-width-control="'100%'" >Selecciona una categoría para cambiar la vista del mapa. Haz clic en los circulos para ver los datos de las reservas.</p>
            
            <dai-leyenda-mapa v-show="selectorCategoria==='1p'"
            titulo="Reservas de crudo (MMB)"
            :para="['distribucion_reserva_provincia_petrolera_1p']"
            />

            <dai-leyenda-mapa v-show="selectorCategoria==='2p'"
            titulo="Reservas de crudo (MMB)"
            :para="['distribucion_reserva_provincia_petrolera_2p']"
            />

            <dai-leyenda-mapa v-show="selectorCategoria==='3p'"
            titulo="Reservas de crudo (MMB)"
            :para="['distribucion_reserva_provincia_petrolera_3p']"
            />

      </template>

      <dai-mapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
      <dai-capa-xyz url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>


      <dai-capa-geojson :visible="selectorCategoria==='1p'"
      id="distribucion_reserva_provincia_petrolera_1p"
      titulo="Reservas de crudo"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.PETROLEO_MMB.toFixed(2)} MMB`"
      url="../geodata/hidrocarburos/reservas2020_1P.geojson"
      :reglas-estilo-capa="[
        {
            clasificacion:'categorias',
            columna : 'CUENCA',
            acomodoCategorias:['Burgos','Cinturon Plegado de Chiapas','Cuencas del Sureste','Golfo de Mexico Profundo','Licitaciones','Plataforma Burro-Picachos','Sabinas','Tampico-Misantla','Veracruz'],
            propiedadObjetivo: 'relleno',
            colores:['#02c620','#c25737','#dd2a60','#39d0d5','#d1308b','#b323cc','#cce187','#d91ac9','#dd9211'],
            tituloVariable:'Cuenca'
        },
        {
            clasificacion:'personalizada',
            columna:'PETROLEO_MMB',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,400],[400,800],[800,1200],[1200,1800]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Millones de barriles'
        }
      ]"
      />

      <dai-capa-geojson :visible="selectorCategoria==='2p'"
      id="distribucion_reserva_provincia_petrolera_2p"
      titulo="Reservas de crudo"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.PETROLEO_MMB.toFixed(2)} MMB`"
      url="../geodata/hidrocarburos/reservas2020_2P.geojson"
      :reglas-estilo-capa="[
        {
            clasificacion:'categorias',
            columna : 'CUENCA',
            acomodoCategorias:['Burgos','Cinturon Plegado de Chiapas','Cuencas del Sureste','Golfo de Mexico Profundo','Licitaciones','Plataforma Burro-Picachos','Sabinas','Tampico-Misantla','Veracruz'],
            propiedadObjetivo: 'relleno',
            colores:['#02c620','#c25737','#dd2a60','#39d0d5','#d1308b','#b323cc','#cce187','#d91ac9','#dd9211'],
            tituloVariable:'Cuenca'
        },
        {
            clasificacion:'personalizada',
            columna:'PETROLEO_MMB',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,400],[400,800],[800,1200],[1200,1800]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Millones de barriles'
        }
      ]"
      />

      <dai-capa-geojson :visible="selectorCategoria==='3p'"
      id="distribucion_reserva_provincia_petrolera_3p"
      titulo="Reservas de crudo"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.PETROLEO_MMB.toFixed(2)} MMB`"
      url="../geodata/hidrocarburos/reservas2020_3P.geojson"
      :reglas-estilo-capa="[
        {
            clasificacion:'categorias',
            columna : 'CUENCA',
            acomodoCategorias:['Burgos','Cinturon Plegado de Chiapas','Cuencas del Sureste','Golfo de Mexico Profundo','Licitaciones','Plataforma Burro-Picachos','Sabinas','Tampico-Misantla','Veracruz'],
            propiedadObjetivo: 'relleno',
            colores:['#02c620','#c25737','#dd2a60','#39d0d5','#d1308b','#b323cc','#cce187','#d91ac9','#dd9211'],
            tituloVariable:'Cuenca'
        },
        {
            clasificacion:'personalizada',
            columna:'PETROLEO_MMB',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,400],[400,800],[800,1200],[1200,1800]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Millones de barriles'
        }
      ]"
      />
  
      </dai-mapa>


      </dai-tarjeta-contenedor-mapa>

    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      
      <p class="texto-primario">Para 2022, 105 campos marinos concentraron el 69% de las reservas 1P mientras que la porción terrestre contiene el 12% de las reservas probadas. En cuanto a reservas 1P terrestres, la provincia petrolera de Tampico Misantla con 140 campos concentra el 14% de las reservas probadas.</p>

    </div>

    <div>

    <div class="tarjeta-contenedor">
          <div class="encabezado">
            <h3>Reservas de petróleo crudo por ubicación</h3>
            <p class="texto-notas">Datos en MMB. Actualización: 2022.</p>
            <select v-model="reservas_ubicacion_select" id="reservas-ubicacion-select">
              <option value="1P">1P (Probadas)</option>
              <option value="2P">2P (1P + Probables)</option>
              <option value="3P">3P (2P + Posibles)</option>
            </select>
          </div>
          <div class="contenido">
            <div class="barrasReservasUbicacion" ref="barrasReservasUbicacion">
            </div>
          </div>
          <div class="tarjeta-contendor-notas">
              <p class="texto-notas"></p>
          </div>
      </div>

      <br>
      
    </div>

    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <p class="texto-primario">En la gráfica interactiva es posible conocer las reservas por cada uno de los campos petroleros a  2022. Tan solo 10 campos - Ayatsil, Maloob, Akal, Ixachi, Zaap, Quesqui, Kayab, Balam, Ichalkil, Pit - concentran el 56% de las reservas de crudo nacional.</p>
      
    </div>

    <div>
      
      <dai-tarjeta-contenedor-mapa :permitir-colapso="false" altura-colapsada="400vh">
      
      <template v-slot:header>
            <h3>Distribución de las Reservas por Campo</h3> 

            <dai-selector-mapa 
            v-model="selectorCategoriaCampo"
            class="control-large" 
            @change="cambioSelector"
            >
                <option value="1p">1P (Probadas)</option>
                <option value="2p">2P (1P + Probables)</option>
                <option value="3p">3P (2P + Posibles)</option>
            </dai-selector-mapa>

            <dai-buscador-mapa 
            para="distribucion_campo_petrolero_1p"
            :acceso-opciones="(f)=>f.CAMPO"
            placeholder="Buscar campo"
            />

            <p class="texto-secundario">Distribución de las Reservas por Campo Petrolero, Ubicación y Categoría.</p>
            <p class="texto-notas " v-width-control="'100%'" >Haz clic en el selector de categoría para cambiar la vista del mapa. Utiliza el cuadro de búsqueda para identificar y hacer zoom sobre los campos petroleros.</p>
            
            <dai-leyenda-mapa v-show="selectorCategoriaCampo==='1p'"
            titulo="Reservas de crudo (MMB)"
            :para="['distribucion_campo_petrolero_1p']"
            />

            <dai-leyenda-mapa v-show="selectorCategoriaCampo==='2p'"
            titulo="Reservas de crudo (MMB)"
            :para="['distribucion_campo_petrolero_2p']"
            />

            <dai-leyenda-mapa v-show="selectorCategoriaCampo==='3p'"
            titulo="Reservas de crudo (MMB)"
            :para="['distribucion_campo_petrolero_3p']"
            />

      </template>

      <dai-mapa
      :extension="[-118.365119934082,14.5320978164673,-86.7104034423828,32.7186546325684]" 
      >
          
      <dai-capa-xyz url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>


      <dai-capa-geojson :visible="selectorCategoriaCampo==='1p'"
      id="distribucion_campo_petrolero_1p"
      titulo="Reservas de crudo"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.PETROLEO_MMB.toFixed(2)} MMB`"
      url="../geodata/hidrocarburos/reservas2020_1P.geojson"
      :reglas-estilo-capa="[
        /*{
            clasificacion:'categorias',
            columna : 'CAMPO',
            propiedadObjetivo: 'relleno',
            tituloVariable:'Campo'
        },*/
        {
            clasificacion:'personalizada',
            columna:'PETROLEO_MMB',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,400],[400,800],[800,1200],[1200,1800]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Millones de barriles'
        }
      ]"
      />

      <dai-capa-geojson :visible="selectorCategoriaCampo==='2p'"
      id="distribucion_campo_petrolero_2p"
      titulo="Reservas de crudo"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.PETROLEO_MMB.toFixed(2)} MMB`"
      url="../geodata/hidrocarburos/reservas2020_2P.geojson"
      :reglas-estilo-capa="[
        /*{
            clasificacion:'categorias',
            columna : 'CAMPO',
            propiedadObjetivo: 'relleno',
            tituloVariable:'Campo'
        },*/
        {
            clasificacion:'personalizada',
            columna:'PETROLEO_MMB',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,400],[400,800],[800,1200],[1200,1800]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Millones de barriles'
        }
      ]"
      />

      <dai-capa-geojson :visible="selectorCategoriaCampo==='3p'"
      id="distribucion_campo_petrolero_3p"
      titulo="Reservas de crudo"
      :zoom-al-dar-click="false"
      :contenidoPopup="(feat)=>`<b>Campo:</b> ${feat.CAMPO}<br><b>Provincia:</b> ${feat.CUENCA}<br><b>Reservas:</b> ${feat.PETROLEO_MMB.toFixed(2)} MMB`"
      url="../geodata/hidrocarburos/reservas2020_3P.geojson"
      :reglas-estilo-capa="[
        /*{
            clasificacion:'categorias',
            columna : 'CAMPO',
            propiedadObjetivo: 'relleno',
            tituloVariable:'Campo'
        },*/
        {
            clasificacion:'personalizada',
            columna:'PETROLEO_MMB',
            propiedadObjetivo:'proporcion',
            clasificacionPersonalizada: [[0,0],[1,200],[200,400],[400,800],[800,1200],[1200,1800]],
            proporciones:[0, 4,6,8,10,15],
            clases:6,
            tituloVariable:'Millones de barriles'
        }
      ]"
      />
  
      </dai-mapa>


      </dai-tarjeta-contenedor-mapa>

      </div>

      
      <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
        <h2>México en el mundo</h2>
        <p class="texto-primario">Gracias la descubrimiento del yacimiento supergigante “Cantarell” (Akal), México se posicionó a principio de los años 80’ como el 5° país con mayores reservas de crudo a nivel mundial, con un máximo histórico de 55 miles de millones de barriles de crudo (MMMB) en los años 1982 y 1983. Sin embargo, estos recursos no renovables se extrajeron a un ritmo acelerado por razones político-económicas, por lo que a final de la década pasada México ocupo el lugar número 20 a nivel mundial, con 6.1 miles de millones de barriles de crudo (MMMB).</p>
      </div>

      <div>

        <dai-tarjeta-contenedor-mapa 
          :colapsada="true" 
          class="full-height"
          altura-colapsada="600vh"
          >
          
          <template v-slot:header>
                <h3 v-width-control="'100%'">Reservas probadas de crudo</h3> 
                <p class="texto-notas " v-width-control="'50%'" >Miles de millones de barriles (MMMB). Datos para 2020.</p>
                
                <dai-buscador-mapa v-width-control="'50%'"
                para="reservas_probadas_mundo"
                :acceso-opciones="(f)=>f.rPais"
                placeholder="Buscar país"
                />

                <dai-leyenda-mapa v-show="true" v-width-control="'100%'"
                titulo="Reservas probadas por país"
                :para="['reservas_probadas_mundo']"
                />


          </template>

          <dai-mapa
          :zoom="0" :centro="[0,0]"
          >
              
          <dai-capa-xyz url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>


          <dai-capa-geojson 
          id="reservas_probadas_mundo"
          titulo="Sistema Eléctrico Nacional - Generación GWh por tecnología"
          :visible="true"
          :zoom-al-dar-click="false"
          :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.rPais}<br><b>2020:</b> ${feat.r2020}<br>`"
          url="../geodata/hidrocarburos/reservas_mundo.geojson"
          :reglas-estilo-capa="[
          
            {
                clasificacion:'linear',
                columna:selectorAnio,
                propiedadObjetivo:'proporcion',
                acomodoCategorias: [10,50,100,200,300],
                proporciones:[4,6,8,10,15],
                clases:5,
                tituloVariable:'Reservas MMMB'
            }
          ]"
          />

          </dai-mapa>

              
          </dai-tarjeta-contenedor-mapa>

        </div>

        <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
          <p class="texto-primario">Las graficas interactivas muestran las reservas de petróleo en el mundo. Como se puede observar las mayores reservas se concentran en los países del Golfo árabe, Venezuela y Canadá. Vale la pena recordar que las reservas de los países árabes no están auditadas y su volumen real ha sido fuertemente cuestionado (Laherrère et al., 2022). Por su parte, el petróleo de Venezuela y Canadá es del no convencional (extra-pesado para Venezuela y arenas bituminosas en Canadá) que tienes costos de extracción y refinación mucho mayor que el petróleo convencional de los demás paises.</p>
        </div>

        <div>

          <div class="graficaPaises" ref="graficaPaises"></div>

          <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
              <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
              <ul class="lista-referencias">
                <li><em><strong>Laherrère, J., Hall, C. A. S. & Bentley, R. (2022).</strong></em>&nbsp; How much oil remains for the world to produce? Comparing assessment methods, and separating fact from fiction. Curr Res Environ Sustain 4, 100174.</li>
                <li><em><strong>Society of Petroleum Engineers (spe-prms) (2007).</strong></em> Petroleum Resources Management System. Society of Petroleum Evaluation Engineers (spee), World Petroleum Council (wpc), American Association of Petroleum Geologists (aapg) <a href="http://www.spe.org/industry/docs/Petroleum_Resources_Management_System_2007.pdf" target="_blank">http://www.spe.org/industry/docs/Petroleum_Resources_Management_System_2007.pdf</a></li>
                <li><em><strong>Comisión Nacional de Hidrocarburos (CNH) (2022).</strong></em> Reporte de la Cuantificación y Certificación de las Reservas de la Nación del año 2022. <a hre="https://www.gob.mx/cnh/acciones-y-programas/cuantificacion-y-certificacion-de-reservas" target="_blank">https://www.gob.mx/cnh/acciones-y-programas/cuantificacion-y-certificacion-de-reservas</a></li>
              </ul>            
          </div>

        </div>
  </div>
</template>
<script>
  
  
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES";
  import am4themes_kelly from "@amcharts/amcharts4/themes/kelly";

  am4core.useTheme(am4themes_kelly);
  

  export default {
    name: 'App',
    components: {
     
    },
    data: function () {
      return {
        selectorAnio:'r2020',
        selectorCategoria:'1p',
        selectorCategoriaCampo:'1p',
        reservasDatos:reservasDatos,
        reservasVariables: reservasVariables,
        reservasUbicacionDatos1P: reservasUbicacionDatos1P,
        reservasUbicacionDatos2P: reservasUbicacionDatos2P,
        reservasUbicacionDatos3P: reservasUbicacionDatos3P,
        reservasUbicacionVariables: reservasUbicacionVariables,
        reservas_ubicacion_select:'1P'
      }   
    },
    methods:{
        cambioSelector:function(e){
          this.series.dataFields.valueY = this.selectorAnio;
        },
        
    },
    watch: {
      reservas_ubicacion_select: function(val, oldVal) {
          if(val == '1P') this.chartReservasUbicacion.data = reservasUbicacionDatos1P;
          else if(val == '2P') this.chartReservasUbicacion.data = reservasUbicacionDatos2P;
          else if(val == '3P') this.chartReservasUbicacion.data = reservasUbicacionDatos3P;
        }
    },
    mounted() {

      let chartReservas = am4core.create(this.$refs.barrasReservas, am4charts.XYChart);
      chartReservas.language.locale = am4lang_es_ES;
      chartReservas.language.locale["_decimalSeparator"] = ".";
      chartReservas.language.locale["_thousandSeparator"] = ",";
      chartReservas.exporting.menu = new am4core.ExportMenu();
      chartReservas.exporting.filePrefix = "ReservasCrudo";
      chartReservas.exporting.useWebFonts = false;
      chartReservas.maskBullets = false;
      chartReservas.paddingLeft = 20;
      chartReservas.paddingRight = 50;
      chartReservas.fontSize = 12;

      chartReservas.data = reservasDatos;

      // Create axes
      let categoryAxis3 = chartReservas.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis3.dataFields.category = "a";
      categoryAxis3.renderer.grid.template.location = 0;
      categoryAxis3.renderer.minGridDistance = 10;

      let valueAxis3 = chartReservas.yAxes.push(new am4charts.ValueAxis());
      //valueAxis3.renderer.inside = true;
      //valueAxis3.renderer.labels.template.disabled = true;
      valueAxis3.title.text = "MMB";
      valueAxis3.min = 0;
      valueAxis3.extraMax = 0.1;
      valueAxis3.calculateTotals = true;

      // Create series
      function createSeries3(field, name, color) {
        
        // Set up series
        let series = chartReservas.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        

        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

        return series;
      }

      for(var i=0; i<reservasVariables.length; i++)
      {
        let v = reservasVariables[i];
        createSeries3(v.id, v.nombre,v.color);
      }


      var totalSeriesProd = chartReservas.series.push(new am4charts.ColumnSeries());
      totalSeriesProd.dataFields.valueY = "total";
      totalSeriesProd.dataFields.categoryX = "a";
      totalSeriesProd.stacked = true;
      totalSeriesProd.hiddenInLegend = true;
      totalSeriesProd.columns.template.strokeOpacity = 0;

      var totalBulletProd = totalSeriesProd.bullets.push(new am4charts.LabelBullet());
      totalBulletProd.dy = -10;
      totalBulletProd.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletProd.label.hideOversized = false;
      totalBulletProd.label.fontSize = 10;
      totalBulletProd.label.fill = am4core.color("#333");
      totalBulletProd.label.background.fillOpacity = 0.2;
      totalBulletProd.label.padding(5, 5, 5, 5);

      // Legend
      chartReservas.legend = new am4charts.Legend();
      chartReservas.legend.useDefaultMarker = true;
      let marker3 = chartReservas.legend.markers.template.children.getIndex(0);
      marker3.cornerRadius(12, 12, 12, 12);
      marker3.strokeWidth = 2;
      marker3.strokeOpacity = 1;
      marker3.stroke = am4core.color("#fff");

      this.chartReservas = chartReservas;


      //barrasReservasUbicacion
      let chartReservasUbicacion = am4core.create(this.$refs.barrasReservasUbicacion, am4charts.XYChart);
      chartReservasUbicacion.language.locale = am4lang_es_ES;
      chartReservasUbicacion.language.locale["_decimalSeparator"] = ".";
      chartReservasUbicacion.language.locale["_thousandSeparator"] = ",";
      chartReservasUbicacion.exporting.menu = new am4core.ExportMenu();
      chartReservasUbicacion.exporting.filePrefix = "RservasCrudoUbicacion";
      chartReservasUbicacion.exporting.useWebFonts = false;
      chartReservasUbicacion.maskBullets = false;
      chartReservasUbicacion.paddingLeft = 20;
      chartReservasUbicacion.paddingRight = 50;
      chartReservasUbicacion.fontSize = 12;

      chartReservasUbicacion.data = reservasUbicacionDatos1P;

      // Create axes
      let categoryAxis4 = chartReservasUbicacion.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis4.dataFields.category = "a";
      categoryAxis4.renderer.grid.template.location = 0;
      categoryAxis4.renderer.minGridDistance = 10;

      let valueAxis4 = chartReservasUbicacion.yAxes.push(new am4charts.ValueAxis());
      //valueAxis3.renderer.inside = true;
      //valueAxis3.renderer.labels.template.disabled = true;
      valueAxis4.title.text = "MMB";
      valueAxis4.min = 0;
      valueAxis4.extraMax = 0.1;
      valueAxis4.calculateTotals = true;

      // Create series
      function createSeries4(field, name, color) {
        
        // Set up series
        let series = chartReservasUbicacion.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "a";
        series.sequencedInterpolation = true;
        series.fill = am4core.color(color);
        series.tooltip.background.fill = am4core.color(color);
        // Make it stacked
        series.stacked = true;
        series.fillOpacity = 0.8;
        series.strokeWidth = 0;
        

        // Configure columns
        series.columns.template.width = am4core.percent(60);
        series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}";

        return series;
      }

      for(var i=0; i<reservasUbicacionVariables.length; i++)
      {
        let v = reservasUbicacionVariables[i];
        createSeries4(v.id, v.nombre,v.color);
      }


      var totalSeriesProdUbicacion = chartReservasUbicacion.series.push(new am4charts.ColumnSeries());
      totalSeriesProdUbicacion.dataFields.valueY = "total";
      totalSeriesProdUbicacion.dataFields.categoryX = "a";
      totalSeriesProdUbicacion.stacked = true;
      totalSeriesProdUbicacion.hiddenInLegend = true;
      totalSeriesProdUbicacion.columns.template.strokeOpacity = 0;

      var totalBulletProdUbicacion = totalSeriesProdUbicacion.bullets.push(new am4charts.LabelBullet());
      totalBulletProdUbicacion.dy = -10;
      totalBulletProdUbicacion.label.text = "{valueY.total.formatNumber('#.0')}";
      totalBulletProdUbicacion.label.hideOversized = false;
      totalBulletProdUbicacion.label.fontSize = 10;
      totalBulletProdUbicacion.label.fill = am4core.color("#333");
      totalBulletProdUbicacion.label.background.fillOpacity = 0.2;
      totalBulletProdUbicacion.label.padding(5, 5, 5, 5);

      // Legend
      chartReservasUbicacion.legend = new am4charts.Legend();
      chartReservasUbicacion.legend.useDefaultMarker = true;
      let marker4 = chartReservasUbicacion.legend.markers.template.children.getIndex(0);
      marker4.cornerRadius(12, 12, 12, 12);
      marker4.strokeWidth = 2;
      marker4.strokeOpacity = 1;
      marker4.stroke = am4core.color("#fff");

      this.chartReservasUbicacion = chartReservasUbicacion;

      //GraficaPaises
      let chartPaises = am4core.create(this.$refs.graficaPaises, am4charts.XYChart);
      chartPaises.scrollbarX = new am4core.Scrollbar();
      chartPaises.language.locale = am4lang_es_ES;
      chartPaises.language.locale["_decimalSeparator"] = ".";
      chartPaises.language.locale["_thousandSeparator"] = ",";
      chartPaises.exporting.menu = new am4core.ExportMenu();
      chartPaises.exporting.filePrefix = "ReservasCrudoMundiales";
      chartPaises.exporting.useWebFonts = false;
      chartPaises.dataSource.url = "../geodata/hidrocarburos/reservas_mundo.csv";
      chartPaises.dataSource.parser = new am4core.CSVParser();
      chartPaises.dataSource.parser.options.useColumnNames = true;
      
      // Create axes
      let categoryAxis = chartPaises.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "Pais";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 10;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.tooltip.disabled = true;
      categoryAxis.renderer.minHeight = 110;
      categoryAxis.fontSize = 11;

      let valueAxis = chartPaises.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.minWidth = 50;
      valueAxis.title.text = "MMB";
      // Create series
      let series = this.series;
      series = chartPaises.series.push(new am4charts.ColumnSeries());
      series.sequencedInterpolation = true;
      series.dataFields.valueY = this.selectorAnio;
      series.dataFields.categoryX = "Pais";
      series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      series.columns.template.strokeWidth = 0;

      series.tooltip.pointerOrientation = "vertical";

      series.columns.template.column.fillOpacity = 0.8;

      // on hover, make corner radiuses bigger
      let hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      series.columns.template.adapter.add("fill", (function(e, a) {
                  return "México" == a.dataItem.dataContext["Pais"] ? "#F00" : "#333"
          }
      ))

      // Cursor
      chartPaises.cursor = new am4charts.XYCursor();

      this.chartPaises = chartPaises;
        
    },
    beforeDestroy() {
      if (this.chartReservas) {
        this.chartReservas.dispose();
      }

      if (this.chartReservasUbicacion) {
        this.chartReservasUbicacion.dispose();
      }

      if (this.chartPaises) {
        this.chartPaises.dispose();
      }

    },
  }

  
const reservasDatos = [
  {
    "a": "2001",
    "1P": 23660.38208,
    "2P": 32642.68929,
    "3P": 39917.88812
  },
  {
    "a": "2002",
    "1P": 22419.03982,
    "2P": 31349.47704,
    "3P": 38286.10446
  },
  {
    "a": "2003",
    "1P": 15123.55966,
    "2P": 27654.68132,
    "3P": 36265.91012
  },
  {
    "a": "2004",
    "1P": 14119.62218,
    "2P": 25933.76374,
    "3P": 34388.92995
  },
  {
    "a": "2005",
    "1P": 12882.17748,
    "2P": 24503.36981,
    "3P": 33312.2478
  },
  {
    "a": "2006",
    "1P": 11813.84889,
    "2P": 23457.95043,
    "3P": 33092.95042
  },
  {
    "a": "2007",
    "1P": 11047.57034,
    "2P": 22081.43966,
    "3P": 31908.76437
  },
  {
    "a": "2008",
    "1P": 10501.23228,
    "2P": 21320.58288,
    "3P": 31211.64501
  },
  {
    "a": "2009",
    "1P": 10404.19531,
    "2P": 20780.02963,
    "3P": 30929.83657
  },
  {
    "a": "2010",
    "1P": 10419.60058,
    "2P": 20440.119,
    "3P": 30497.28897
  },
  {
    "a": "2011",
    "1P": 10160.99558,
    "2P": 20897.43132,
    "3P": 30534.48262
  },
  {
    "a": "2012",
    "1P": 10025.16635,
    "2P": 18573.26734,
    "3P": 30612.52086
  },
  {
    "a": "2013",
    "1P": 10073.18997,
    "2P": 18530.08146,
    "3P": 30816.53751
  },
  {
    "a": "2014",
    "1P": 9812.085114,
    "2P": 17612.40168,
    "3P": 29327.75612
  },
  {
    "a": "2015",
    "1P": 9710.973241,
    "2P": 16475.46865,
    "3P": 25825.131
  },
  {
    "a": "2016",
    "1P": 7640.738487,
    "2P": 13272.65157,
    "3P": 19454.61374
  },
  {
    "a": "2017",
    "1P": 7037.033969,
    "2P": 12849.54181,
    "3P": 19970.29165
  },
  {
    "a": "2018",
    "1P": 6464.165605,
    "2P": 12280.68872,
    "3P": 19419.79555
  },
  {
    "a": "2019",
    "1P": 6065.877884,
    "2P": 11945.02446,
    "3P": 19046.87794
  },
  {
    "a": "2020",
    "1P": 6346.780414,
    "2P": 12102.10085,
    "3P": 17726.47683
  },
  {
    "a": "2021",
    "1P": 6119.732156,
    "2P": 11470.47385,
    "3P": 17119.08707
  },
  {
    "a": "2022",
    "1P": 6058.692068,
    "2P": 11219.61276,
    "3P": 16688.13575
  },
  {
    "a": "2023",
    "1P": 6154.6,
    "2P": 11515,
    "3P": 17515.5
  }
],
reservasVariables = [
  {"id":"1P","nombre":"1P (Probadas)","color":"#001028"},
  {"id":"2P","nombre":"2P (1P + Probables)","color":"#1b4a91"},
  {"id":"3P","nombre":"3P (2P + Posibles)","color":"#118dff"}
];

const reservasUbicacionDatos1P = [
  {
    "a": "2001",
    "marino": 12624.18927,
    "terrestre": 11036.19281
  },
  {
    "a": "2002",
    "marino": 11774.95085,
    "terrestre": 10644.08897
  },
  {
    "a": "2003",
    "marino": 10793.20177,
    "terrestre": 4330.35789
  },
  {
    "a": "2004",
    "marino": 9915.657612,
    "terrestre": 4203.964563
  },
  {
    "a": "2005",
    "marino": 9093.650915,
    "terrestre": 3788.526561
  },
  {
    "a": "2006",
    "marino": 8278.71054,
    "terrestre": 3535.138345
  },
  {
    "a": "2007",
    "marino": 7726.120876,
    "terrestre": 3321.449466
  },
  {
    "a": "2008",
    "marino": 7192.006733,
    "terrestre": 3309.225542
  },
  {
    "a": "2009",
    "marino": 7220.089522,
    "terrestre": 3184.10579
  },
  {
    "a": "2010",
    "marino": 7349.24483,
    "terrestre": 3070.355746
  },
  {
    "a": "2011",
    "marino": 7022.569477,
    "terrestre": 3138.426106
  },
  {
    "a": "2012",
    "marino": 6862.524619,
    "terrestre": 3162.641728
  },
  {
    "a": "2013",
    "marino": 6915.233657,
    "terrestre": 3157.956314
  },
  {
    "a": "2014",
    "marino": 6855.73839,
    "terrestre": 2956.346724
  },
  {
    "a": "2015",
    "marino": 6964.193069,
    "terrestre": 2746.780172
  },
  {
    "a": "2016",
    "marino": 5695.798889,
    "terrestre": 1944.939598
  },
  {
    "a": "2017",
    "marino": 5364.026428,
    "terrestre": 1673.007541
  },
  {
    "a": "2018",
    "marino": 5053.182863,
    "terrestre": 1410.982742
  },
  {
    "a": "2019",
    "marino": 4552.941406,
    "terrestre": 1512.936478
  },
  {
    "a": "2020",
    "marino": 4876.323818,
    "terrestre": 1470.456596
  },
  {
    "a": "2021",
    "marino": 4389.639103,
    "terrestre": 1730.093053
  },
  {
    "a": "2022",
    "marino": 4220.233569,
    "terrestre": 1838.458504
  }
],
reservasUbicacionDatos2P = [
  {
    "a": "2001",
    "marino": 18016.54696,
    "terrestre": 14626.14233
  },
  {
    "a": "2002",
    "marino": 17254.70153,
    "terrestre": 14094.77552
  },
  {
    "a": "2003",
    "marino": 16181.27548,
    "terrestre": 11473.40584
  },
  {
    "a": "2004",
    "marino": 14904.38992,
    "terrestre": 11029.37382
  },
  {
    "a": "2005",
    "marino": 13929.43788,
    "terrestre": 10573.93194
  },
  {
    "a": "2006",
    "marino": 13184.09926,
    "terrestre": 10273.85117
  },
  {
    "a": "2007",
    "marino": 11936.93133,
    "terrestre": 10144.50833
  },
  {
    "a": "2008",
    "marino": 11218.15772,
    "terrestre": 10102.42516
  },
  {
    "a": "2009",
    "marino": 11075.73306,
    "terrestre": 9704.296568
  },
  {
    "a": "2010",
    "marino": 10619.81224,
    "terrestre": 9820.306764
  },
  {
    "a": "2011",
    "marino": 10979.28279,
    "terrestre": 9918.148539
  },
  {
    "a": "2012",
    "marino": 11090.82593,
    "terrestre": 7482.441403
  },
  {
    "a": "2013",
    "marino": 11156.66671,
    "terrestre": 7373.414743
  },
  {
    "a": "2014",
    "marino": 10675.81365,
    "terrestre": 6936.588036
  },
  {
    "a": "2015",
    "marino": 10071.98482,
    "terrestre": 6403.483832
  },
  {
    "a": "2016",
    "marino": 9106.24643,
    "terrestre": 4166.40514
  },
  {
    "a": "2017",
    "marino": 9279.154853,
    "terrestre": 3570.386954
  },
  {
    "a": "2018",
    "marino": 8995.921189,
    "terrestre": 3284.767533
  },
  {
    "a": "2019",
    "marino": 8330.338728,
    "terrestre": 3614.685731
  },
  {
    "a": "2020",
    "marino": 8432.299343,
    "terrestre": 3669.801502
  },
  {
    "a": "2021",
    "marino": 7521.369581,
    "terrestre": 3949.104267
  },
  {
    "a": "2022",
    "marino": 7275.440998,
    "terrestre": 3944.171772
  }
],
reservasUbicacionDatos3P = [
  {
    "a": "2001",
    "marino": 21154.29401,
    "terrestre": 18763.59412
  },
  {
    "a": "2002",
    "marino": 20230.77334,
    "terrestre": 18055.33112
  },
  {
    "a": "2003",
    "marino": 18602.06534,
    "terrestre": 17663.84479
  },
  {
    "a": "2004",
    "marino": 17302.26166,
    "terrestre": 17086.66829
  },
  {
    "a": "2005",
    "marino": 16506.18586,
    "terrestre": 16806.06193
  },
  {
    "a": "2006",
    "marino": 16601.12974,
    "terrestre": 16491.82068
  },
  {
    "a": "2007",
    "marino": 15632.50002,
    "terrestre": 16276.26436
  },
  {
    "a": "2008",
    "marino": 15073.74142,
    "terrestre": 16137.90359
  },
  {
    "a": "2009",
    "marino": 15059.19129,
    "terrestre": 15870.64528
  },
  {
    "a": "2010",
    "marino": 14816.43868,
    "terrestre": 15680.85029
  },
  {
    "a": "2011",
    "marino": 14983.0742,
    "terrestre": 15551.40841
  },
  {
    "a": "2012",
    "marino": 15725.75379,
    "terrestre": 14886.76707
  },
  {
    "a": "2013",
    "marino": 16081.76835,
    "terrestre": 14734.76916
  },
  {
    "a": "2014",
    "marino": 15835.32229,
    "terrestre": 13492.43383
  },
  {
    "a": "2015",
    "marino": 14798.55307,
    "terrestre": 11026.57793
  },
  {
    "a": "2016",
    "marino": 13228.25946,
    "terrestre": 6226.354281
  },
  {
    "a": "2017",
    "marino": 14234.93443,
    "terrestre": 5735.357217
  },
  {
    "a": "2018",
    "marino": 13839.31448,
    "terrestre": 5580.481069
  },
  {
    "a": "2019",
    "marino": 13113.0025,
    "terrestre": 5933.875441
  },
  {
    "a": "2020",
    "marino": 11899.65338,
    "terrestre": 5826.82345
  },
  {
    "a": "2021",
    "marino": 10821.21505,
    "terrestre": 6297.87202
  },
  {
    "a": "2022",
    "marino": 10615.3587,
    "terrestre": 6072.777055
  }
],
reservasUbicacionVariables = [
  {"id":"marino","nombre":"Marino","color":"#0078d7"},
  {"id":"terrestre","nombre":"Terrestre","color":"#ada11d"}
];


</script>
<style scoped lang="scss">
  
  .barrasReservas
  {
    width: 100%;
    height: 500px;
  }

  .barrasReservasUbicacion {
    width: 100%;
    height: 500px;
  }

  .graficaPaises {
    width: 100%;
    height: 600px;
  }


</style>
